import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Spin } from "antd";
import { useEffect, useState } from "react";
import { TemplateCenterCard } from "./card.js";
function TemplateCenterCards({ templates, showHidden, showDisabled = true, ...rest }) {
    const [initialLoaded, setInitialLoaded] = useState(false);
    useEffect(()=>{
        if (!initialLoaded && templates.length > 0) {
            setInitialLoaded(true);
        }
    }, [
        initialLoaded,
        templates.length
    ]);
    return templates.length > 0 || initialLoaded ? /*#__PURE__*/ _jsx(_Fragment, {
        children: templates.filter(({ isHidden })=>showHidden ? true : !isHidden).filter(({ consumerData: { isDisabled } })=>showDisabled ? true : !isDisabled).map((template)=>/*#__PURE__*/ _jsx(TemplateCenterCard, {
                template: template,
                ...rest
            }, template.identifier))
    }) : /*#__PURE__*/ _jsx(Spin, {
        spinning: true,
        style: {
            marginTop: 10
        }
    });
}
export { TemplateCenterCards };
